/**
 * Tabs Listener
 *
 * Shared click delegation helpers for role-based tab interactions.
 */

import { FormBase } from "../form-base-form";

class TabsListenerFormBase extends FormBase {
    public getClosestElement(
        root: Event | EventTarget | Element | null | undefined,
        selector: string,
    ): HTMLElement | null {
        return this.closest(root, selector, HTMLElement);
    }
}

const tabsListenerFormBase = new TabsListenerFormBase();

export function bindRoleClick(
    root: HTMLElement,
    role: string,
    onMatch: (event: Event, element: HTMLElement) => void,
): void {
    const escapedRole = typeof CSS !== "undefined" && typeof CSS.escape === "function" ? CSS.escape(role) : role;
    const selector = `[data-role="${escapedRole}"]`;

    root.addEventListener("click", (event) => {
        const element = tabsListenerFormBase.getClosestElement(event, selector);
        if (!(element instanceof HTMLElement)) return;
        onMatch(event, element);
    });
}
